import styled from 'styled-components';
import styles from '../../../components/reward-bounty/reward-bounty.module.css';
import { Button, message, Table, Dropdown, Menu, Modal, Form, Input, Cascader, Space, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {useState, useEffect, useLayoutEffect, useCallback} from 'react';
import { useSelector } from 'react-redux';
import { currentUser } from '../../../features/user/userSlice';
import { getUserReport, getCompanyReportList, getlevels } from '../../../api/Report';
import {delMyReport, confirmReport, publishReport, fixedReport} from '../../../api/User';
import {
  DeleteOutlined,
} from '@ant-design/icons';
import React from 'react';
import _cloneDeep from 'lodash/cloneDeep'

import RewardBounty from '../../../components/reward-bounty';
import {getAuthorWallet} from "../../../api/Auhtor";
import { AlertTag } from '../../../components/AlertTag';
import { CustomInputNumberMyReport, CustomQuestionCircleOutlined, CustomTooltip } from '../../../components/CustomForm';
import {ConfirmModal} from "./components/ConfirmModal";
import { CustomTable } from '../../../components/Common';
import ConfirmIcon from '../../../assets/images/icons/icon-confirm@2x.png'
import FixedIcon from '../../../assets/images/icons/icon-fixed@2x.png'
import IgnoreIcon from '../../../assets/images/icons/icon-ignore@2x.png'
import PublishIcon from '../../../assets/images/icons/icon-publish@2x.png'
import RewardIcon from '../../../assets/images/icons/icon-reward-bounty@2x.png'
import ViewIcon from '../../../assets/images/icons/icon-view@2x.png'

const TableContainer = styled.div`
  overflow: hidden;
  height: 100%;
  padding: 0 4px;
  @media screen and (max-width: 600px) {
    padding: 0 0 0 10px;
  }
`;

export const CardTitle = styled.div`
  position: relative;
  font-size: 24px;
  margin-top: 20px;
  font-weight: 600;
  padding-left: 14px;
  ::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 80%;
    width: 5px;
    background-color: #40a9ff;
  }
`;

const CommonTable = ({ ...props }) => {
  // hooks translation
  const { t } = useTranslation();
  // state table
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    total: 0,
    currentPage: 1,
    perSize: 10,
  });

  // state confirmModal
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [confirmType, setConfirmType] = useState(null);
  const [confrimSerialNumber, setConfirmSerialNumber] = useState(null);

  // state delete confirm
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [deleteSerialNumber, setDeleteSerialNumber] = useState('');
  const [Columns, setColumns] = useState([]);

  // state rewardModal
  const [rewardVisible, setRewardVisible] = useState(false);
  const [rewardSerialNumber, setRewardSerialNumber] = useState(null);
  const [userRewardAddress, setUserRewardAddress] = useState(null);
  const [platformRewardAddress, setPlatformRewardAddress] = useState(null);

  const [whitehatRewards, setWhitehatRewards] = useState('');
  const [platformRewards, setPlatformRewards] = useState('');

  const [minPoints, setMinPoints] = useState(0);
  const [maxPoints, setMaxPoints] = useState(0);
  const [initPoints, setInitPoints] = useState(0);

  const [reportSeverity, setReportSeverity] = useState('');
  const [reportCount, setReportCount] = useState(0);
  const [totalScore, setTotalScore] = useState(0);

  // const [rewardAmount, setRewardAmount] = useState(0);

  // redux get UserData from redux
  const _USER = useSelector(currentUser);

  function pointsOnChange(value){
    form.setFieldValue({points:value});
  }

  const getCompanyActions = (data) => {
    const {
      serial_number,
      user_id,
      level,
      points,
      state
    } = data
    if (state === 1) {
      return (
          <>
            <Button
                type={'text'}
                shape={'round'}
                className="public-button"
                onClick={() => {
                  openConfirmVisible({ type: 1, serial_number, level, points});
                }}
            >
              <img src={ConfirmIcon} width={14} alt='' />
              {t('user_center.MyRreport.Confirm')}
            </Button>
            <Button
                type={'text'}
                shape={'round'}
                className="public-button"
                onClick={() => {
                  openConfirmVisible({ type: 2, serial_number, level });
                }}
            >
              <img src={IgnoreIcon} width={14} alt='' />
              {t('CommonTable.is_Ignore')}
            </Button>
          </>)
    } else if (state === 2) {
      return (
          <Button
              type={'text'}
              shape={'round'}
              className="public-button"
              onClick={() => {
                openConfirmVisible({ type: 4, serial_number});
              }}
          >
            <img src={FixedIcon} width={14} alt='' />
            {t('user_center.MyRreport.Fixed')}
          </Button>
      )
    } else if (state === 3) {
      return (
          <>
            <Button
                type={'text'}
                shape={'round'}
                className="public-button"
                onClick={() => {
                  handleOpenRewardBounty({serial_number, user_id});
                }}
            >
              <img src={RewardIcon} width={14} alt='' />
              {t('user_center.MyRreport.RewardBounty')}
            </Button>
          </>)
    }else if (state === 4) {
      return (
          <>
            <Button
                type={'text'}
                shape={'round'}
                className="public-button"
                onClick={() => {
                  openConfirmVisible({ type: 3, serial_number });
                }}
            >
              <img src={PublishIcon} width={14} alt='' />
              {t('user_center.MyRreport.Publish')}
            </Button>
          </>)
    }
    return (
        <Link
            target={'_blank'}
            to={`/reports/${serial_number}`}
        >
          <Button
              type={'text'}
              shape={'round'}
              className="public-button">
            <img src={ViewIcon} width={14} alt='' />
            {t('user_center.MyRreport.View')}
          </Button>
        </Link>
    )
  }

  // coustomData: common table Columns
  let common_Columns = [
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.title')}
        </span>
      ),
      dataIndex: 'title',
      key: 'title',
      render: (_, { serial_number }) => (
        <Link
          target={'_blank'}
          style={{
            color: '#fff',
          }}
          to={`/reports/${serial_number}`}
        >
          {_}
        </Link>
      ),
      // width: '220px',
      className: 'common-table-title',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.level')}
        </span>
      ),
      dataIndex: 'level',
      key: 'level',
      render: (_, { level }) => <AlertTag type={level.id} space={3} />,
      width: '150px',
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.score')}
        </span>
      ),
      dataIndex: 'points',
      key: 'points',
      render: (_, { points }) => <span>{points}</span>,
      width: '50px',
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.category')}
        </span>
      ),
      dataIndex: 'category',
      key: 'category',
      render: (_, { category }) => <span>{category?.name}</span>,
      width: '150px',
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.createDate')}
        </span>
      ),
      dataIndex: 'created_at',
      key: 'created_at',
      width: '120px',
      align: 'center',
      render: (_) => moment.unix(_).format('YYYY-MM-DD'),
      className: 'common-table-cell-date',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.state')}
        </span>
      ),
      dataIndex: 'state',
      key: 'state',
      render: (_, { state }) => {
        if (state === 0) {
          return (
            <span
              style={{
                color: '#FFA31A',
              }}
            >
              {t('CommonTable.audit_status.wait')}
            </span>
          );
        }
        if (state === 1) {
          return (
            <span
              style={{
                color: '#00EEC2',
              }}
            >
              {t('CommonTable.audit_status.pass')}
            </span>
          );
        }
        if (state === 2) {
          return (
            <span
              style={{
                color: '#00EEC2',
              }}
            >
              {t('CommonTable.company_confirm_status.pass')}
            </span>
          );
        }
        if (state === 3) {
          return (
            <span
              style={{
                color: '#00EEC2',
              }}
            >
              {t('CommonTable.is_fixed_status.1')}
            </span>
          );
        }
        if (state === 4) {
          return (
            <span
              style={{
                color: '#00EEC2',
              }}
            >
              {t('CommonTable.reward_status.1')}
            </span>
          );
        }
        if (state === 5) {
          return (
            <span
              style={{
                color: '#00EEC2',
              }}
            >
              {t('CommonTable.is_public_status.1')}
            </span>
          );
        }
        if (state === -1) {
          return (
            <span
              style={{
                color: '#CD1D2E',
              }}
            >
              {t('CommonTable.audit_status.reject')}
            </span>
          );
        }
        if (state === -2) {
          return (
            <span
              style={{
                color: '#CD1D2E',
              }}
            >
              {t('CommonTable.company_confirm_status.reject')}
            </span>
          );
        }
      },
      width: '110px',
      align: 'center',
      className: 'common-table-author',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.operate')}
        </span>
      ),
      // dataIndex: 'operate',
      // key: 'operate',
      render: (
        _,
        data
      ) => {
        const {
          serial_number,
          state
        } = data
        if (_USER && _USER.user?.type === 0) {
          return state === 0 ? (
            <div>
              <Button
                type={'text'}
                shape={'round'}
                className="delet-button"
                onClick={() => {
                  handleClickDelete(serial_number);
                }}
              >
                <DeleteOutlined /> {t('user_center.MyRreport.delete')}
              </Button>
            </div>
          ) : <Link
              target={'_blank'}
              to={`/reports/${serial_number}`}
          >
            <Button
                type={'text'}
                shape={'round'}
                className="public-button">
              <img src={ViewIcon} width={14} alt='' />
              {t('user_center.MyRreport.View')}
            </Button>
          </Link>;
        } else {
          return getCompanyActions(data);
        }
      },
      width: '160px',
      align: 'center',
      // fixed: 'right',
      className: 'common-table-author',
    },
  ];

  // fetch table data
  const fetchData = async (page,pageSize) => {
    setPageOptions({
      ...pageOptions,
      currentPage: page,
      pageSize,
    });
    setLoading(true);
    let methodName;
    if (_USER?.user?.type === 0) {
      methodName = getUserReport;
    } else {
      methodName = getCompanyReportList;
    }
    try {
      const params = {
        page,
        pageSize,
      };
      const { code, data } = await methodName(params);
      if (code === '10000') {
        if (_USER?.user?.type === 0) {
          setReportCount(data.reports.total);
          setTotalScore(data.total_score);
          setData(data.reports.list);
          setPageOptions({
            currentPage: data.reports.current_page,
            perSize: data.reports.per_page,
            total: data.reports.total,
          });
        }else{
          setReportCount(data.total);
          setData(data.list);
          setPageOptions({
            currentPage: data.current_page,
            perSize: data.per_page,
            total: data.total,
          });
        }
      }

      setLoading(false);
    } catch (error) {
      // console.log(error);
    }
  };

  // fetch delete report api
  const DeleteReport = async (id, callback) => {
    try {
      const { code } = await delMyReport({
        serial_number: id,
      });
      if (code === '10000') {
        message.success(t('CommonTable.delete_success'));
      }
    } catch (error) {}
    callback();
    fetchData(pageOptions.currentPage, pageOptions.perSize);
  };

  const [form] = Form.useForm();

  const rewardAmountChange = function(e){
    form.setFieldsValue({reward_amount:e.target.value})
  }

  const levelChange = function(value){
    setLevelId(value[0]);
    if(value[0] === 1){
      setMinPoints(1);
      setMaxPoints(9);
      if(initPoints >=1 && initPoints<=9){
        form.setFieldsValue({points:initPoints})
      }else{
        form.setFieldsValue({points:1})
      }
    }else if(value[0] === 2){
      setMinPoints(10);
      setMaxPoints(39);
      if(initPoints >=10 && initPoints<=39){
        form.setFieldsValue({points:initPoints})
      }else{
        form.setFieldsValue({points:10})
      }
    }else if(value[0] === 3){
      setMinPoints(40);
      setMaxPoints(69);
      if(initPoints > 40 && initPoints <= 69){
        form.setFieldsValue({points:initPoints})
      }else{
        form.setFieldsValue({points:40})
      }
    }else if(value[0] === 4){
      setMinPoints(70);
      setMaxPoints(89);
      if(initPoints > 70 && initPoints <= 89){
        form.setFieldsValue({points:initPoints})
      }else{
        form.setFieldsValue({points:70})
      }
    }else if(value[0] === 5){
      setMinPoints(90);
      setMaxPoints(100);
      if(initPoints > 90 && initPoints <= 100){
        form.setFieldsValue({points:initPoints})
      }else{
        form.setFieldsValue({points:90})
      }
    }
    form.setFieldsValue({level_id:value[0]})
  }

  // fetch confirm report api
  const handleConfirmReport = async (type, id, callback) => {
    const rewardAmount = form.getFieldValue('reward_amount') ?? 0;
    const levelId = form.getFieldValue('level_id');
    const points = form.getFieldValue('points');
    try {
      const { code } = await confirmReport({
        confirm_type: type,
        serial_number: id,
        reward_amount: rewardAmount,
        level_id: levelId,
        points: points,
      });
      if (code === '10000') {
        if (type === 1) {
          message.success(t('CommonTable.confirm_success'));
        } else {
          message.success(t('CommonTable.ignored_success'));
        }
      }
    } catch (error) {}
    // setDeletLoading(false);
    callback();
    fetchData(pageOptions.currentPage, pageOptions.perSize);
  };

  // fetch publish report api
  const handlePublishReport = async (id, callback) => {
    try {
      const { code } = await publishReport({
        serial_number: id,
      });
      if (code === '10000') {
        callback();
        message.success(t('CommonTable.publish_success'));
      }
    } catch (error) {}
    fetchData(pageOptions.currentPage, pageOptions.perSize);
  };

  // function openConfirmModal
  const [levelId, setLevelId]= useState(0)
  const [levelName, setLevelName]= useState('')

  const handleFixedReport = async (id, callback) => {
    try {
      const { code } = await fixedReport({
        serial_number: id,
      });
      if (code === '10000') {
        callback();
        message.success(t('CommonTable.fixed_success'));
      }
    } catch (error) {}
    fetchData(pageOptions.currentPage, pageOptions.perSize);
  }
  const openConfirmVisible = async({ type, serial_number, level, points }) => {
    setConfirmType(type);
    setConfirmSerialNumber(serial_number);
    if(type === 1){
      setLevelId(level.id);
      setLevelName(level.name);
      setInitPoints(points);
      if(level.id===1){
        setMinPoints(1);
        setMaxPoints(9);
        if(points >=1 && points<=9){
          form.setFieldsValue({points:points})
        }else{
          form.setFieldsValue({points:1})
        }
      }else if(level.id===2){
        setMinPoints(10);
        setMaxPoints(39);
        if(points >=10 && points<=39){
          form.setFieldsValue({points:points})
        }else{
          form.setFieldsValue({points:10})
        }
      }else if(level.id===3){
        setMinPoints(40);
        setMaxPoints(69);
        if(points >=40 && points<=69){
          form.setFieldsValue({points:points})
        }else{
          form.setFieldsValue({points:40})
        }
      }else if(level.id===4){
        setMinPoints(70);
        setMaxPoints(89);
        if(points >=70 && points<=89){
          form.setFieldsValue({points:points})
        }else{
          form.setFieldsValue({points:70})
        }
      }else if(level.id===5){
        setMinPoints(90);
        setMaxPoints(100);
        if(points >=90 && points<=100){
          form.setFieldsValue({points:points})
        }else{
          form.setFieldsValue({points:90})
        }
      }
      const {data} = await getlevels()
      setReportSeverity(data);
    }

    setConfirmVisible(true);
  };

  // function confirm action ---confirmModal
  const handleConfirmOk = async () => {
    if(confirmType===1){
      try {
        await form.validateFields(['reward_amount'])
      } catch (err) {
        return err
      }
    }
    if (confirmType === 3) {
      return handlePublishReport(confrimSerialNumber, handleConfirmCancel);
    } else if (confirmType === 4) {
      return handleFixedReport(confrimSerialNumber, handleConfirmCancel)
    }
    handleConfirmReport(confirmType, confrimSerialNumber, handleConfirmCancel);
  };

  // function cancel action ---confirmModal
  const handleConfirmCancel = () => {
    setConfirmVisible(false);
    setConfirmType(null);
    setConfirmSerialNumber(null);
    setInitPoints(0);
    setLevelId(0);
    setLevelName('');
    form.setFieldsValue({reward_amount:''})
  };

  // JSX Components DeleteModal
  const DeleteModal = ({ visible, handleOk, handleCancel }) => {
    return (
      <Modal open={visible} onOk={handleOk} onCancel={handleCancel}>
        Are you sure you want to delete the report?
      </Modal>
    );
  };

  // function Open deleteModal
  const handleClickDelete = (serial_number) => {
    setDeleteSerialNumber(serial_number);
    setDeleteVisible(true);
  };

  // function confirm delete
  const handleDeleteOK = () => {
    DeleteReport(deleteSerialNumber, () => {
      setDeleteVisible(false);
    });
  };

  // function cancel delete
  const handleDeleteCancel = () => {
    setDeleteSerialNumber('');
    setDeleteVisible(false);
  };

  const dataSource = [
    {
      key: '1',
      severity: 'Informational',
      score: '0 - 9',
    },
    {
      key: '2',
      severity: 'Low',
      score: '10 - 39',
    },
    {
      key: '3',
      severity: 'Medium',
      score: '40 - 69',
    },
    {
      key: '4',
      severity: 'High',
      score: '70 - 89',
    },
    {
      key: '5',
      severity: 'Critical',
      score: '90 - 100',
    }
  ];
  
  const columns = [
    {
      title: 'Severity',
      dataIndex: 'severity',
      key: 'severity',
    },
    {
      title: 'Score',
      dataIndex: 'score',
      key: 'score',
    }
  ];
  /**
   * reward bounty
   */

  // openRewardBounty
  const handleOpenRewardBounty = async ({ serial_number, user_id}) => {
    const {data} = await getAuthorWallet(serial_number)
    setRewardVisible(true);
    setRewardSerialNumber(serial_number);
    setUserRewardAddress(data.user_address);
    setPlatformRewardAddress(data.platform_address);

    setWhitehatRewards(data.whitehat_rewards);
    setPlatformRewards(data.platform_rewards);
  };

  // LayoutEffect set table columns
  useLayoutEffect(() => {
    // setColumns([...common_Columns]);
    if (_USER && _USER.user && _USER.user.type === 0) {
      const columns = _cloneDeep(common_Columns)
      columns.splice(1, 0, {
        title: (
            <span
                style={{
                  fontSize: '14px',
                  fontWeight: 400,
                }}
            >
          {t('CommonTable.project')}
        </span>
        ),
        key: 'company',
        render: (_, { company }) => (
            <Link
                target={'_blank'}
                style={{
                  color: '#fff',
                }}
                to={`/bounties/${company.name}`}
            >
              {company.name}
            </Link>
        ),
        width: '150px',
        // className: 'common-table-title',
      },)
      setColumns(columns);
    } else {
      // common_Columns.splice(5, 0, ...company_Columns);
      setColumns(common_Columns);
    }
  }, [_USER]);

  // Effect init
  useEffect(() => {
    // window scroll to top
    window.scrollTo(0, 0);
    // init table data
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TableContainer>
      <ConfirmModal
        visible={confirmVisible}
        handleOk={handleConfirmOk}
        handleCancel={handleConfirmCancel}
        modalTitle={confirmType===1 ? 'Confirm Report' : confirmType === 2 ? 'Ignore Report' : confirmType === 4 ? 'Fixed Report' : 'Publish Report'}
      >
        {
          confirmType === 1 ?
              (<div><div className={styles['reward-bounty-container']}>
                    <Form
                        form={form}
                        labelAlign="left"
                        labelCol={{
                          sm: {span: 8},
                          md: {span: 6},
                          lg: {span: 4},
                          xl: {span: 4},
                          xxl: {span: 4},
                        }}
                        // initialValues={{
                        //   level_id:levelId,
                        // }}
                    >
                      <Form.Item
                          label={t('addreport.Severity/Points')}
                          style={{
                            lineHeight:'50px',
                          }}
                      >
                        <div
                            style={{
                              width: '100%',
                              // maxWidth: '470px',
                            }}
                        >
                          <Form.Item
                              noStyle
                              rules={[
                                {
                                  required: true,
                                  message: t('addreport.message.validate_level'),
                                },
                              ]}
                          >

                            <Cascader
                                allowClear={true}
                                style={{
                                  width: 'calc(25% - 5px)',
                                  marginRight: '10px',
                                }}
                                fieldNames={{
                                  label: 'name',
                                  value: 'id',
                                  children: 'children',
                                }}
                                key={levelId}
                                defaultValue={levelId}
                                options={reportSeverity}
                                onChange={levelChange}
                            />

                          </Form.Item>
                          <Form.Item
                              noStyle
                              name={'points'}
                              rules={[
                                {
                                  required: true,
                                  message: t('addreport.message.validate_points'),
                                },
                              ]}
                          >
                            <CustomInputNumberMyReport style={{
                              width: 'calc(20% - 5px)',
                            }} min={minPoints} max={maxPoints} onChange={pointsOnChange} />
                          </Form.Item>
                          <CustomTooltip arrowPointAtCenter={true} placement="right" title={<span>
                            <a href="https://nvd.nist.gov/vuln-metrics/cvss/v3-calculator" target="_blank" rel="noreferrer" style={{color:"#6ee6c6",textDecoration:'underline'}}>CVSS Calculator Score</a> * 10
                            <br />
                            <CustomTable size="small" pagination={false} dataSource={dataSource} columns={columns} style={{
                              marginTop:'5px',
                            }} 
                            />
                          </span>} style={{
                            whiteSpace:'nowrap',
                            width:'100%'
                          }}>
                            <CustomQuestionCircleOutlined style={{
                              width: 'calc(5% + 10px)',
                            }} />
                          </CustomTooltip>
                          {/* <CustomTooltip  placement="topRight" title={<span><a href="https://nvd.nist.gov/vuln-metrics/cvss/v3-calculator" target="_blank" rel="noreferrer" style={{color:"#6ee6c6",textDecoration:'underline'}}>CVSS Calculator Score</a> * 10</span>} arrowPointAtCenter={true} style={{
                            width:'100%'
                          }}>
                            <CustomQuestionCircleOutlined style={{
                              width: 'calc(5% + 10px)',

                              // marginLeft:'7px'
                            }} />
                          </CustomTooltip> */}
                        </div>
                      </Form.Item>

                      <Form.Item
                          name='reward_amount'
                          label='Rewards Amount'
                          style={{
                            lineHeight:'50px',
                          }}
                          rules={[{required: true}]}
                      >
                        <Input type="text" onChange={rewardAmountChange} style={{maxWidth:'50%'}} className='confirm_report_input'  suffix="USDC"></Input>
                        {/* <span style={{marginLeft:'10px'}}><b>USDC</b></span> */}
                      </Form.Item>
                    </Form>
                  </div>
                  </div>
              ) :
              confirmType === 2
                  ? `Are you sure you want to change the report state to ignored?`:
                  confirmType === 4 ?
                      "Are you sure you want to change the report state to fixed?"
                  : `Are you sure you want to change the report state to published?`
        }


        {/* {confirmType === 1
          ? `Are you sure you want to confirm the report?`
          : confirmType === 2
          ? `Are you sure you want to ignore the report?`
          : `Are you sure you want to public the report?`} */}
      </ConfirmModal>
      {_USER && _USER.user ? (
        <RewardBounty
          visible={rewardVisible}
          setVisible={setRewardVisible}
          address={userRewardAddress}
          platformAddress={platformRewardAddress}
          whiteHatRewards={whitehatRewards}
          platformRewards={platformRewards}
          userName={_USER.user?.name}
          serial_number={rewardSerialNumber}
          refreshData={() => fetchData(pageOptions.currentPage, pageOptions.perSize)}
        />
      ) : null}
      {
        _USER && _USER.user && _USER.user.type === 0 ? (
          <div style = {{
            padding:'16px'
          }}>
            <Row>
              <Col span={24}>
                <span style = {{fontWeight: 'bold'}}>
                  Report Count : {reportCount}
                </span>
                <span style = {{fontWeight: 'bold',marginLeft:'20px'}}>
                  Total Score : {totalScore}
                </span>
                
              </Col>
              {/* <Col span={12}><span style = {{fontWeight: 'bold'}}>Total Score : {totalScore}</span></Col> */}
            </Row>
          </div>
        ) : null}
      <Table
        columns={Columns}
        dataSource={data}
        pagination={{
          // ...pageOptions,
          total: pageOptions.total,
          current: pageOptions.currentPage,
          pageSize: pageOptions.perSize,
          onChange(page, pageSize) {
            // setPageOptions({
            //   ...pageOptions,
            //   current: page,
            //   pageSize,
            // });
            fetchData(page, pageSize);
          },
        }}
        loading={loading}
        className="author-table"
        rowKey="created_at"
        scroll={{
          x: true,
        }}
        style={{
          height: '100%',
        }}
      />
      <DeleteModal
        visible={deleteVisible}
        handleCancel={handleDeleteCancel}
        handleOk={handleDeleteOK}
      />
    </TableContainer>
  );
};

export default CommonTable;
